import * as styles from './List.css';
import type { ParagraphElementProps } from './Paragraph.types';

export const OrderedList = (props: ParagraphElementProps) => {
  const { children } = props;
  return <ol className={styles.listElement}>{children}</ol>;
};

export const BulletList = (props: ParagraphElementProps) => {
  const { children } = props;
  return <ul className={styles.listElement}>{children}</ul>;
};
